const useIcon = () => {
  const iconImage = (payload) => {
    const origin = window.location.origin;
    const iconURL = process.env.REACT_APP_ICON_URL.includes("http")
      ? process.env.REACT_APP_ICON_URL
      : `${origin}/${process.env.REACT_APP_ICON_URL}`;

    let name = payload.toLowerCase();

    return `${iconURL}/32/color/${name}.png`;
  };

  return [iconImage];
};

export default useIcon;
